import { Auth } from 'aws-amplify'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useAuth } from '../../../app/modules/auth/index'
import { PageTitle } from '../../../_metronic/layout/core'
import { CardCustom1 } from '../../../_metronic/partials/content/cards/CardCustom1'
import {
  MixedWidget2,
  MixedWidget10,
  MixedWidget11,
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget5,
  ListsWidget6,
  TablesWidget10,
  MixedWidget8,
  TilesWidget1,
  TilesWidget4,
  TilesWidget2,
  TilesWidget5,
  TilesWidget3,
} from '../../../_metronic/partials/widgets'

import { DashboardViewOrganization } from '../modules/organizations/DashboardViewOrganization'
const API_URL_API = process.env.REACT_APP_API_URL_BACKEND + '/dashboardData'

const DashboardPage = () => {

  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true)
  const [organizations, setOrganizations] = useState([])
  const [branches, setBranches] = useState([])
  const [departments, setDepartments] = useState([])
  const [doctors, setDoctors] = useState([])

  useEffect(() => {
    getData()
  }, [])


  const getData = async () => {

    try {

      const auth = await Auth.currentSession();
      const token = auth.getAccessToken().getJwtToken();

      const { data: result } = await axios.get(API_URL_API, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      setOrganizations(result.data.organizations);
      setBranches(result.data.branches);
      setDepartments(result.data.departments);
      setDoctors(result.data.doctors);

      setLoading(false);
    } catch (err) {
      console.log(err)
    }
  };

  return loading ? (
    <div className='fv-row mb-7'>
      <div className='d-flex flex-center'>
        <span className="spinner-grow text-dark mx-2"></span>
        <span className="spinner-grow text-dark mx-2"></span>
        <span className="spinner-grow text-dark mx-2"></span>
        <span className="spinner-grow text-dark mx-2"></span>
      </div>
    </div>
  ) : (
    <>
      {/* Here we will load components according to user Role */}




      {/*
    <div className='row g-5 g-xl-8'>
      <div className='col-xl-4'>
        <MixedWidget8
          className='card-xxl-stretch mb-xl-3'
          chartColor='success'
          chartHeight='150px'
        />
      </div>

      <div className='col-xl-8'>
        <div className='row gx-5 gx-xl-8 mb-5 mb-xl-8'>
          <div className='col-xl-3'>
            <TilesWidget1 className='card-xl-stretch' />
          </div>
          <div className='col-xl-9'>
            <TilesWidget4 className='card-xl-stretch' />
          </div>
        </div>

        <div className='row gx-5 gx-xl-8 mb-5 mb-xl-8'>
          <div className='col-xl-6'>
            <TilesWidget2 className='card-xl-stretch mb-5 mb-xl-8' />
            <div className='row gx-5 gx-xl-8'>
              <div className='col-xl-4'>
                <TilesWidget5
                  className='card-xxl-stretch bg-body'
                  svgIcon='/media/icons/duotune/general/gen002.svg'
                  titleClass='text-dark'
                  descriptionClass='text-muted'
                  iconClass='svg-icon-success'
                  title='8,600'
                  description='New Customers'
                />
              </div>
              <div className='col-xl-8'>
                <TilesWidget5
                  className='card-xxl-stretch bg-primary'
                  svgIcon='/media/icons/duotune/general/gen025.svg'
                  titleClass='text-white'
                  descriptionClass='text-white'
                  iconClass='svg-icon-white'
                  title='790'
                  description='New Products'
                />
              </div>              
            </div>
          </div>
          <div className='col-xl-6'>
            <TilesWidget3 className='card-xl-stretch mb-5 mb-xl-8' />
          </div>
        </div>
      </div>
    </div>
    */}

      {/* begin::Row */}
      {/* 
    <div className='row gy-5 g-xl-8'>
      <div className='col-xxl-4'>
        <MixedWidget2
          className='card-xl-stretch mb-xl-8'
          chartColor='danger'
          chartHeight='200px'
          strokeColor='#cb1e46'
        />
      </div>
      <div className='col-xxl-4'>
        <ListsWidget5 className='card-xxl-stretch' />
      </div>
      <div className='col-xxl-4'>
        <MixedWidget10
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='150px'
        />
        <MixedWidget11
          className='card-xxl-stretch-50 mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='175px'
        />
      </div>
    </div>
    */}

      {/* end::Row */}
      {/* begin::Row */}






      {/* end::Row */}

      {/* begin::Row */}
      {currentUser.userSession.user.role_id == 1 ? (
        <>
          <div className='row g-6 g-xl-9 mb-6 mb-xl-9'>
            <div className='col-12 col-sm-12 col-xl'>
              <CardCustom1 icon='far fa-building' color='bg-info' title='Organizations' description={`Total = ${organizations}`} />
            </div>
            <div className='col-12 col-sm-12 col-xl'>
              <CardCustom1 icon='fa fa-sitemap' color='bg-warning' title='Branches' description={`Total = ${branches}`} />
            </div>
            <div className='col-12 col-sm-12 col-xl'>
              <CardCustom1 icon='fa fa-house-medical' color='bg-danger' title='Departemtns' description={`Total = ${departments}`} />
            </div>
            <div className='col-12 col-sm-12 col-xl'>
              <CardCustom1 icon='fa fa-user-doctor' color='bg-success' title='Doctors' description={`Total = ${doctors}`} />
            </div>
          </div>
        </>
      ) : null
      }
      {/* end::Row */}
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
